








import { Component, Prop, Vue } from 'vue-property-decorator';
import CreditAccountForm from './CreditAccountForm.vue';
import { ACCOUNT_IN_CREDIT } from '../../statics';

@Component({
  components: {
    CreditAccountForm
  }
})
export default class AccountInCreditForm extends Vue {
  @Prop({ type: String, required: true }) listOfAssetsId!: string;

  type = ACCOUNT_IN_CREDIT;
}
